const FormResources = 
{
    form_data_assignment_time_square_footage:
    {
        day_id: '',
        shift_id: '',
    },

    form_data_assignment_weekly_minutes:
    {
        show_available_minutes: false
    },

    form_data_assignment_info_by_shift:
    {
        day_id: '',
        shift_id: '',
        management_team: 0,
        budgeted_ftes: 0,
        non_productive_percentage: 9.45
    },

    form_data_assignment_duties_with_clean_code:
    {
        daily_assignment_id: [],
        task_id: [],
    },

    form_data_assignment_utilization_time:
    {
        day_id: '',
    },
    form_data_daily_assignment_rooms: {
        assigned_frequency_symbol: 1,
        closed: '',
        assigned_frequency: '',
        status_id: [],
        task_type_id: [],
        task_id: [],
        building_id: [],
        level_id: [],
        area_id: []
    },

    form_format_assignment_time_square_footage: [
        {
            css_class:  'col-md-3',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Day:',
            model_name: 'day_id',
            ref:        'day_id_input',
            ref_alt:    'day_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-3',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Shift:',
            model_name: 'shift_id',
            ref:        'shift_id_input',
            ref_alt:    'shift_id_input_alt',
            required:   false,
        },
    ],

    form_format_assignment_info_by_shift: [
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Day:',
            model_name: 'day_id',
            ref:        'day_id_input',
            ref_alt:    'day_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Shift:',
            model_name: 'shift_id',
            ref:        'shift_id_input',
            ref_alt:    'shift_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'NonProductive Percentage:',
            model_name: 'non_productive_percentage',
            ref:        'non_productive_percentage_input',
            ref_alt:    'non_productive_percentage_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Management Team:',
            model_name: 'management_team',
            ref:        'management_team_input',
            ref_alt:    'management_team_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Budgeted FTEs:',
            model_name: 'budgeted_ftes',
            ref:        'budgeted_ftes_input',
            ref_alt:    'budgeted_ftes_input_alt',
            required:   false,
            style:      'right: 0;'
        },
    ],


    form_format_assignment_duties_with_clean_code: [
        {
            css_class:  'col-md-2',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Daily Assignment:',
            model_name: 'daily_assignment_id',
            ref:        'daily_assignment_id_input',
            ref_alt:    'daily_assignment_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select assignment(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name'
        },
        {
            css_class:  'col-md-2',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Task:',
            model_name: 'task_id',
            ref:        'task_id_input',
            ref_alt:    'task_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select task(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name'
        },
    ],


    form_format_assignment_utilization_time: [
        {
            css_class:  'col-md-3',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Day:',
            model_name: 'day_id',
            ref:        'day_id_input',
            ref_alt:    'day_id_input_alt',
            required:   true,
        },
    ],

    form_format_daily_assignment_rooms: [
        {
            css_class:  'col-md-4',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Status:',
            model_name: 'status_id',
            ref:        'status_id_input',
            ref_alt:    'status_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select option(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name'
        },
        {
            css_class:  'col-md-4',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Closed?:',
            model_name: 'closed',
            ref:        'closed_input',
            ref_alt:    'closed_input_alt',
            required:   false,
            style:      ''
        },
        {
            css_class:  'col-md-4 mr-0 ml-0',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Task Type:',
            model_name: 'task_type_id',
            ref:        'task_type_id_input',
            ref_alt:    'task_type_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select option(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name'
        },
        {
            css_class:  'col-md-4 mr-0 ml-0',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   true,
            step:       '',
            name:       'Task:',
            model_name: 'task_id',
            ref:        'task_id_input',
            ref_alt:    'task_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select option(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name',
        },
        {
            css_class:  'col-md-4 mr-0 ml-0',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Building:',
            model_name: 'building_id',
            ref:        'building_id_input',
            ref_alt:    'building_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select building(s)',
            close_on_option: false,
            track_by: 'name'
        },
        {
            css_class:  'col-md-4 mr-0 ml-0',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Level:',
            model_name: 'level_id',
            ref:        'level_id_input',
            ref_alt:    'level_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select level(s)',
            close_on_option: false,
            track_by: 'name'
        },
        {
            css_class:  'col-md-4 mr-0 ml-0',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Area:',
            model_name: 'area_id',
            ref:        'area_id_input',
            ref_alt:    'area_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select area(s)',
            close_on_option: false,
            track_by: 'name'
        },
    ],

    form_format_assignment_weekly_minutes: [
        {
            css_class:  'col-md-6',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Show available minutes calculation:',
            model_name: 'show_available_minutes',
            ref:        'show_available_minutes_input',
            ref_alt:    'show_available_minutes_input_alt',
            required:   false,
        },
    ],

    simbol_options:[
        {
            id:     1,
            name:   '=',
        },
        {
            id:     2,
            name:   '<',
        },
        {
            id:     3,
            name:   '>',
        },
    ],
}

export default FormResources;